import { callAPI } from '../../../../services/api.service';

export interface OrderStatusBackfillStatus {
  isRunning: boolean;
  startedAt?: string;
  finishedAt?: string;
  scannedOrders: number;
  backfilledOrders: number;
  skippedOrders: number;
  statusCounts: Record<string, number>;
  scannedBooks: number;
  backfilledBooks: number;
  errors: string[];
}

export interface OrderStatusBackfillResponse {
  status: number;
  message: string;
  data?: OrderStatusBackfillStatus;
}

export const startOrderStatusBackfill = async (
  batchSize?: number
): Promise<OrderStatusBackfillResponse> => {
  return await callAPI('admin/orders/backfill-status/start', { batchSize }, 'POST');
};

export const getOrderStatusBackfillStatus = async (): Promise<OrderStatusBackfillResponse> => {
  return await callAPI('admin/orders/backfill-status/status');
};
